import { Polygon } from '@App/app/entities/layer/polygons/polygon.model';
import { Component } from '@angular/core';
import { BaseLayerPropertiesComponent } from '../base-layer-properties/base-layer-properties.component';

@Component({
  selector: 'app-area-polygon-properties',
  templateUrl: './area-polygon-properties.component.html',
})
export class AreaPolygonPropertiesComponent extends BaseLayerPropertiesComponent<Polygon> {}
